import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/handlers/apiHandler.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-document-viewer',
  standalone: false,
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit {
  pdfForm: FormGroup;
  uuid: string;

  constructor(private apiHelper: ApiService, private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.pdfForm  =  this.formBuilder.group({
      pdfUuid: ['', Validators.required]
    });
  }

  changePDF() {
    this.uuid = this.pdfForm.value['pdfUuid'];
  }
}
